var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 61,
    viewBox: "0 0 86 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_140935",
    "data-name": "Ret\\xE2ngulo 140935",
    width: 86,
    height: 61,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_161827",
    "data-name": "Grupo 161827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26991",
    "data-name": "Caminho 26991",
    d: "M22.418,64h65.06c2.414,0,3.814,1.975,3.111,4.389L83.148,93.949,79.22,107.438a6.347,6.347,0,0,1-5.668,4.389H8.492c-2.414,0-3.814-1.975-3.112-4.389L16.75,68.389A6.348,6.348,0,0,1,22.418,64",
    transform: "translate(-4.108 -50.575)",
    fill: "#e6e9f0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26992",
    "data-name": "Caminho 26992",
    d: "M5.663,0H21.889c1.66.013,2.456.173,2.439,1.573V4.563c0,1.929.89,1.6,2.412,1.731H69.9c1.793,0,3.975.515,3.973,3.828v1.223H18.31a8.418,8.418,0,0,0-7.666,5.889L0,53.789.037,5.622A5.643,5.643,0,0,1,5.663,0",
    fill: "#e6e9f0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26993",
    "data-name": "Caminho 26993",
    d: "M138.116,106.95a15.915,15.915,0,1,1,.058,22.448,15.873,15.873,0,0,1-.058-22.448",
    transform: "translate(-105.492 -80.864)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_161828",
    "data-name": "Grupo 161828",
    transform: "translate(6806.489 6690.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26994",
    "data-name": "Caminho 26994",
    d: "M1.061-.012l17.213-.2A1.032,1.032,0,0,1,19.324.836l-.061,5.207a1.092,1.092,0,0,1-1.074,1.074l-17.213.2A1.032,1.032,0,0,1-.073,6.269l.061-5.207A1.092,1.092,0,0,1,1.061-.012Z",
    transform: "translate(-6766.832 -6662.075) rotate(45)",
    fill: "#e6e9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26995",
    "data-name": "Caminho 26995",
    d: "M1.061.012l17.213.2a1.092,1.092,0,0,1,1.074,1.074l.061,5.207A1.032,1.032,0,0,1,18.36,7.543l-17.213-.2A1.092,1.092,0,0,1,.073,6.269L.012,1.061A1.032,1.032,0,0,1,1.061.012Z",
    transform: "translate(-6753 -6656.952) rotate(135)",
    fill: "#e6e9f0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.e9d856abbbc5daca2db2a5ad120a5be6.svg";
export { ForwardRef as ReactComponent };